import { useFigmaStore } from './useFigmaStore'
import { authFetch } from '../../lib/api'
import { usePulseMemory } from '../PulseMemory/usePulseMemory'

export function FigmaImportPanel() {
  const { figmaUrl, setFigmaUrl, token, setToken, pages, setPages, setError, error } = useFigmaStore()
  const loading = useFigmaStore(s => s.loading)
  const setLoading = useFigmaStore(s => s.setLoading)
  const project = usePulseMemory(s => s.memory.project) || 'default'

  const loadPages = async () => {
    if (!figmaUrl || !token) return
    setLoading(true); setError('')
    try {
      const r = await authFetch('/api/figma/pages', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ figmaUrl, token }),
      })
      if (!r.ok) { setError((await r.json()).error); setLoading(false); return }
      const data = await r.json()
      setPages(data.pages)
    } catch (e: any) { setError(e.message) }
    setLoading(false)
  }

  const input: React.CSSProperties = { width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid var(--border)', background: 'var(--bg-3)', color: 'var(--text-1)', fontSize: 11, fontFamily: 'var(--font-mono)', boxSizing: 'border-box' }
  const btn: React.CSSProperties = { padding: '8px 14px', borderRadius: 6, border: 'none', background: 'var(--accent)', color: '#fff', cursor: 'pointer', fontSize: 11, fontFamily: 'var(--font-mono)', width: '100%' }

  return (
    <div style={{ padding: 16, fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-1)' }}>
      <h3 style={{ margin: '0 0 4px', fontSize: 14, color: 'var(--accent)' }}>🎨 Figma Import</h3>
      <p style={{ margin: '0 0 14px', color: 'var(--text-2)', fontSize: 11 }}>
        Load pages → click thumbnail → generate code.<br/>
        <span style={{ fontSize: 10 }}>Project: <strong style={{ color: 'var(--text-1)' }}>{project}</strong></span>
      </p>

      <div style={{ marginBottom: 10 }}>
        <label style={{ fontSize: 10, color: 'var(--text-2)', display: 'block', marginBottom: 4 }}>Figma URL</label>
        <input style={input} placeholder="https://www.figma.com/design/..." value={figmaUrl} onChange={e => setFigmaUrl(e.target.value)} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <label style={{ fontSize: 10, color: 'var(--text-2)', display: 'block', marginBottom: 4 }}>
          API Token <a href="https://www.figma.com/settings" target="_blank" rel="noreferrer" style={{ color: 'var(--accent)' }}>(get one)</a>
        </label>
        <input style={input} type="password" placeholder="figd_..." value={token} onChange={e => setToken(e.target.value)} />
      </div>

      <button style={btn} onClick={loadPages} disabled={loading || !figmaUrl || !token}>
        {loading && pages.length === 0 ? '⏳ Loading...' : pages.length > 0 ? '✅ Pages loaded — see editor' : '📄 Load Pages'}
      </button>

      {error && <div style={{ marginTop: 10, padding: 8, background: '#dc262620', border: '1px solid #dc2626', borderRadius: 6, color: '#f87171', fontSize: 10 }}>{error}</div>}

      {pages.length > 0 && (
        <div style={{ marginTop: 12, fontSize: 10, color: 'var(--text-2)' }}>
          {pages.length} page(s) loaded. Click a thumbnail in the editor area to generate code.
        </div>
      )}
    </div>
  )
}
